export default __webpack_public_path__ + "static/media/step2.47a2e794.png";